require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vice-prsidence-recherche-0-3-1.json") })
        }
      }, "path---vice-prsidence-recherche-0-3-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---vice-prsidence-recherche-0-3-1!./.cache/json/vice-prsidence-recherche-0-3-1.json
// module id = 604
// module chunks = 231608221292675